import React from 'react'
import { BaseForm, Input } from '../../../../components/Form'

import { getMessage } from '../../../../lib/translator'

// Simple URL search (no autocomplete). Submits a flat { url: '<typed>' }, which ListingPage
// serialises to GET /account-service/endpoint?url=<typed> (backend filters url LIKE).
class EndpointsFilter extends BaseForm {
  render() {
    const { Form } = this.components
    const { SubmitButton } = this.buttons
    return (
      <Form>
        <div className="form-fields">
          <Input
            type="text"
            name="url"
            label={getMessage('endpoint.url')}
            placeholder={getMessage('endpoint.url.placeholder')}
            {...this.generateStateMappers({
              stateKeys: ['url'],
              loseEmphasisOnFill: true,
            })}
          />
        </div>
        <div className="form-actions">
          <SubmitButton>{getMessage('endpoint.submit')}</SubmitButton>
        </div>
      </Form>
    )
  }
}

export default EndpointsFilter
